module.exports = __webpack_public_path__ + "static/media/event-driven.6ea13e8d.svg";